import {
  formatFtwe,
  formatRateField,
  ftweMoved,
  movedRates,
} from '../lib/rates'
import { FTWE_LABEL, type RateCardChange } from '../types'

/** What a rate card change would do: each rate and the FTWE multiplier it
 *  moves as current to proposed (compared as numbers, so 0.5500 to 0.55 is no
 *  move), then the server's consequences. */
export function RateCardChangePreview({ change }: { change: RateCardChange }) {
  const moved = movedRates(change)
  const ftweMoves = ftweMoved(change)
  const { ftwe_current: ftweCurrent, ftwe_proposed: ftweProposed } = change
  return (
    <div className="grid gap-3 rounded-md border border-border p-3 text-sm">
      {moved.length > 0 || ftweMoves ? (
        <ul className="grid gap-1">
          {moved.map(({ key, label }) => (
            <li key={key} className="flex justify-between gap-4">
              <span className="text-muted-foreground">{label}</span>
              <span className="font-semibold">
                {formatRateField(key, change.current[key])} &rarr;{' '}
                {formatRateField(key, change.proposed[key])}
              </span>
            </li>
          ))}
          {ftweMoves && (
            <li className="flex justify-between gap-4">
              <span className="text-muted-foreground">{FTWE_LABEL}</span>
              <span className="font-semibold">
                {formatFtwe(ftweCurrent.tier, ftweCurrent.multiplier)} &rarr;{' '}
                {formatFtwe(ftweProposed.tier, ftweProposed.multiplier)}
              </span>
            </li>
          )}
        </ul>
      ) : (
        <p className="text-muted-foreground">No rate changes.</p>
      )}
      <ul className="list-disc space-y-1 pl-5">
        {change.consequences.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </div>
  )
}
